import React, { useState } from 'react';
import styled, { css } from 'styled-components';

const Info = styled.div`
  background: center /contain no-repeat;
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.15));
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 2;
  width: 47px;
  height: 47px;
  background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/game/btn_how_off.png);
  cursor: pointer;

  ${(props) => props.act && css`
    background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/game/btn_how_on.png);
  `}
`;

const InfoDetail = styled.span`
  background: center /contain no-repeat;
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.15));
  display: none;
  position: absolute;
  z-index: 1;
  top: 40px;
  right: 40px;
  width: 443px;
  height: 144px;
  background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/game/game3_how.png);

  ${(props) => props.act && css`
    display: block;
  `}
`;

export const GameInfo = () => {
  const [act, setAct] = useState(false);

  return (
    <>
      <Info onClick={() => setAct(!act)} act={act}/>
      <InfoDetail act={act}/>
    </>
  );
};